import { IsNotEmpty, IsOptional, IsString, IsArray, Length } from 'class-validator';

export class PriceGetPricesRequest {
    @IsNotEmpty()
    @IsString()
    @Length(36, 36)
    public priceTypeUuid: string;

    @IsOptional()
    @IsArray()
    @IsString({ each: true })
    @Length(36, 36, { each: true })
    public nomPositionUuids?: string[];

    constructor(data?: Partial<PriceGetPricesRequest>) {
        this.priceTypeUuid = data?.priceTypeUuid;
        this.nomPositionUuids = data?.nomPositionUuids;
    }
}

